export enum MissingLabelModal {
  MISSING_LABEL_PRINTING_LABELS = "MISSING_LABEL_PRINTING_LABELS",
  MISSING_LABEL_UNEXPECTED_SKU = "MISSING_LABEL_UNEXPECTED_SKU",
  MISSING_LABEL_UNSOLVABLE_BOX = "MISSING_LABEL_UNSOLVABLE_BOX",
  MISSING_LABEL_INPUT_BARCODE_MODAL = "MISSING_LABEL_INPUT_BARCODE_MODAL",
  MISSING_LABEL_QUIT = "MISSING_LABEL_QUIT",
}
